export default __webpack_public_path__ + "static/media/45f4e15a7644add3.9697e5daef707d56efcba7ee6270bf3c.svg";